import { PlayerConfig } from '@/interfaces/player-config.interface';
import videojs from 'video.js';

/**
 * Player/iFrame API
 * send player event to parent window
 * https://develop.earthtv.com/jira/browse/WV-22
 */
class IFrameService {
  private parentUrl: string = '';
  private parentOrigin: string = '';
  private parentElementId: string = '';
  private handshakeSuccess = false;

  /**
   * Sets weather or not the powerlink is visible etc
   * @param playerConfig
   */
  public initParent(playerConfig: PlayerConfig) {
    if (typeof window.postMessage !== 'undefined' && this.parentOrigin !== '' && this.handshakeSuccess) {
      const message = {
        type: 'setData',
        powerlink: playerConfig.advertisment.enabled,
        accountId: playerConfig.accountId,
        sourceId: playerConfig.sourceId,
      };
      parent.postMessage(message, this.parentOrigin);
      this.sendStateChangeEvent(playerConfig);
    }
  }

  public handshake(): Promise<string> {
    return new Promise((resolve) => {
      const wait = setTimeout(() => {
        clearTimeout(wait);
        const parentUrl = window.location !== window.parent.location ? document.referrer : document.location.href;
        const url = new URL(parentUrl);
        this.parentUrl = url.host;
        this.parentOrigin = url.origin;
        resolve(this.parentUrl);
      }, 5000);

      window.addEventListener('message', (e) => {
        if (e.data && e.data.type === 'handshake') {
          this.handshakeSuccess = true;
          clearTimeout(wait);
          this.parentUrl = e.data.parentUrl;
          this.parentOrigin = e.data.parentOrigin;
          this.parentElementId = e.data.parentElementId;
          resolve(this.parentUrl);
        }
      });
    });
  }

  /**
   * Send Player events to iframe
   * @param event
   * @param metadata
   */
  public sendStateChangeEvent(playerConfig: PlayerConfig, player?: videojs.Player) {
    // send event and meta data to parent
    if (this.handshakeSuccess) {
      let country = '';
      let city = '';

      if (playerConfig && playerConfig.location && playerConfig.location.country) {
        country = playerConfig.location.country[playerConfig.language];
        city = playerConfig.location.city[playerConfig.language];
      }

      const data = {
        playerId: this.parentElementId,
        isLive: playerConfig.live,
        country,
        city,
        isPaused: player ? player.paused() : true,
      };
      const message = {
        type: 'etvp_onStateChange',
        metadata: data,
      };

      parent.postMessage(message, this.parentOrigin);
    }
  }
}

export const iFrameService = new IFrameService();
